/* eslint-disable react/default-props-match-prop-types */
/* eslint-disable no-empty */
/* eslint-disable react/require-default-props */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-shadow */
import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Spacer } from '@cleartrip/bento/components/Spacing'
import Chip from '../Chip'

const Field = props => {
  const {
    className,
    wrapperClassName,
    onBlur,
    onFocus,
    hasError,
    label,
    showIcon,
    actionTitle,
    actionOnClick,
    errorMessage,
    value,
    type,
    Icon,
    iconOnClick,
    onChange,
    disabled,
    id,
    isGenderField,
    isMobileNumberField,
    actionClassName,
    hideLabel,
    ...otherProps
  } = props

  const inputRef = useRef()
  const [showLabel, setShowLabel] = useState(true)

  const fieldClass = classNames(
    'bw-1',
    'bs-solid',
    'w-100p',
    'fs-3',
    'h-14',
    'br-2',
    {
      'bc-neutral-100': !hasError,
      'focus:bc-secondary-500': !hasError,
      'error-border': hasError,
      'bg-neutral-0': disabled
    },
    className
  )

  const inputClass = classNames('ml-1', 'pt-18px', {
    'ml-5': showIcon && Icon,
    'c-white': type === 'date' && value === ''
  })

  const getId = (id = '') => {
    return id?.split(' ').join('') || ''
  }

  useEffect(() => {
    let inputField = ''
    if (label || id) {
      inputField = document.querySelector(
        `#${getId(id.toLowerCase() || label.toLowerCase())}`
      )

      if (inputField?.value) {
        inputField.parentNode.classList.add('active')
        if (hideLabel) {
          setShowLabel(false)
        }
      } else if (inputField !== document.activeElement) {
        inputField?.parentNode.classList.remove('active')

        if (hideLabel) {
          setShowLabel(true)
        }
      } else if (inputField === document.activeElement) {
        inputField.parentNode.classList.add('active')
        if (hideLabel) {
          setShowLabel(false)
        }
      }
    }
  }, [value, hasError])

  const handleFocus = e => {
    const { target } = e
    target.parentNode.classList.add('active')
    if (!hideLabel) {
    } else {
      setShowLabel(false)
    }
    if (typeof onFocus === 'function') {
      onFocus()
    }
  }

  const labelClass = classNames(
    'fs-3',
    'fw-500',
    'c-neutral-500',
    'ml-1',
    'pe-none',
    {
      'ml-48': showIcon && Icon
    }
  )
  const wrapperClass = classNames(wrapperClassName, 'p-relative')

  const handleBlur = e => {
    const { target } = e
    if (!target.value) {
      target.parentNode.classList.remove('active')
      if (hideLabel) {
        setShowLabel(true)
      }
    }

    if (typeof onBlur === 'function') {
      onBlur(e)
    }
  }

  return (
    <div className={wrapperClass}>
      {isGenderField ? (
        <>
          <div className={`flex ${''}`}>
            <Chip
              isSelected={value === 'Mr'}
              onClick={() => onChange('Mr')}
              title="Mr."
            />
            <Spacer className="ml-3" />
            <Chip
              isSelected={value === 'Ms'}
              onClick={() => onChange('Ms')}
              title="Ms."
            />
            <Spacer className="ml-3" />
            <Chip
              isSelected={value === 'Mrs'}
              onClick={() => onChange('Mrs')}
              title="Mrs."
            />
          </div>
          {hasError && errorMessage && (
            <div className="fw-500 fs-2 c-error mt-2 ml-1">{errorMessage}</div>
          )}
        </>
      ) : isMobileNumberField ? (
        <>
          <div
            className={`field-container flex bg-white flex-middle ${fieldClass}`}
            onClick={() => inputRef.current.focus()}
          >
            <div
              className="pl-2 pr-3 fs-4 lh-24 c-neutral-500"
              onClick={iconOnClick}
              style={{
                borderRight: 'solid 1px #e7e7e7'
              }}
            >
              +91
            </div>

            {label && showLabel && (
              <label
                className={labelClass}
                htmlFor={label.toLowerCase()}
                style={{ left: '70px' }}
              >
                {label}
              </label>
            )}
            <input
              ref={inputRef}
              className="ml-4"
              id={getId(id.toLowerCase() || label.toLowerCase())}
              type={type}
              value={value}
              onBlur={handleBlur}
              onFocus={handleFocus}
              onChange={onChange}
              disabled={disabled}
              {...otherProps}
            />
          </div>
        </>
      ) : (
        <>
          <div
            className={`field-container flex bg-white flex-middle ${fieldClass}`}
            onClick={() => inputRef.current.focus()}
          >
            {showIcon && Icon && (
              <div onClick={iconOnClick}>
                <Icon height="24" width="24" />
              </div>
            )}

            {label && showLabel && (
              <label className={labelClass} htmlFor={label.toLowerCase()}>
                {label}
              </label>
            )}
            <input
              ref={inputRef}
              className={inputClass}
              id={getId(id.toLowerCase() || label.toLowerCase())}
              type={type}
              value={value}
              onBlur={handleBlur}
              onFocus={handleFocus}
              onChange={onChange}
              disabled={disabled}
              {...otherProps}
            />
            {actionTitle && (
              <div
                className={classNames('c-pointer fw-600 fs-3 lh-24 mr-1 ml-2', {
                  [actionClassName]: actionClassName,
                  'c-neutral-500': !actionClassName
                })}
                onClick={e => {
                  e.stopPropagation()
                  actionOnClick()
                }}
              >
                {actionTitle}
              </div>
            )}
          </div>

          {hasError && errorMessage && (
            <div className="ml-1 fw-500 fs-2 c-error">{errorMessage}</div>
          )}
        </>
      )}
    </div>
  )
}

Field.propTypes = {
  /**
   * Class to be appended to the wrapping element
   */
  className: PropTypes.string,
  /**
   * Html type of the input text/number/email etc.
   */
  type: PropTypes.string,
  /**
   * Boolean to indicate an error state
   */
  hasError: PropTypes.bool,
  /**
   * Classes for internal wrapper
   */
  wrapperClassName: PropTypes.string,
  /**
   * Date input field variant
   */
  dateField: PropTypes.bool,
  label: PropTypes.string.isRequired,
  id: PropTypes.string,
  isGenderField: PropTypes.bool,
  showIcon: PropTypes.bool,
  actionTitle: PropTypes.string,
  actionOnClick: PropTypes.func,
  errorMessage: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  iconOnClick: PropTypes.func,
  onChange: PropTypes.func,
  disabled: PropTypes.bool
}

Field.defaultProps = {
  className: '',
  type: 'text',
  wrapperClassName: '',
  hasError: false,
  dateField: false,
  label: 'Label',
  id: '',
  isGenderField: false,
  value: '',
  iconOnClick: () => { },
  showIcon: false,
  errorMessage: 'Error',
  disabled: false,
  actionOnClick: () => { },
  onChange: () => { }
}

Field.displayName = 'Field'

export default Field
